export const routes = {
    HOME:"/",
    REGISTER:"/register",
    PRIVACY_POLICY:"/privacy-policy"
}